module.exports = __webpack_public_path__ + "img/nington-qrcode-android.3f70aa7a.png";